/**
 * Asynchronously loads the component for DealershipGroupDashboardsPage
 */

import { lazyLoad } from 'utils/loadable';

export const DealershipGroupDashboardsPage = lazyLoad(
  () => import('./index'),
  module => module.DealershipGroupDashboardsPage,
);
